import { BannerLandscape, BannerLandscapeWrapper } from 'components/banner/bannerLandscape';
import { IppicaInPartenza } from 'components/ippicaInPartenza';
import { selectIppicaRaceDetail } from 'features/ippica/selectors';
import { useTypedSelector } from 'lib/centralStore';
import { DatoCmsVisualComposer } from 'lib/datoCms/types';
import { convertInBannerType } from 'lib/datoCms/utils';
import React, { useMemo } from 'react';
import { isTruthy } from 'utility/functions';
import { IppicaBgContainer } from '../ippicaBgContainer/IppicaBgContainer';
import { IppicaBroadcast } from '../ippicaBroadcast';
import { IppicaCarousel } from '../ippicaCarousel';
import { IppicaWithTabContainer } from '../ippicaWithTabContainer';
import { QuickSlot } from 'components/quickSlot';

// eslint-disable-next-line no-unused-vars
enum enManagedComponents {
  // eslint-disable-next-line no-unused-vars
  promo = 'promo',
  // eslint-disable-next-line no-unused-vars
  quick_slot = 'quick_slot',
  // eslint-disable-next-line no-unused-vars
  banner_on_page = 'banner_on_page',
  // eslint-disable-next-line no-unused-vars
  corse_in_partenza_block = 'corse_in_partenza_block',
  // eslint-disable-next-line no-unused-vars
  broadcast_block = 'broadcast_block',
  // eslint-disable-next-line no-unused-vars
  corse_news_block = 'corse_news_block',
  // eslint-disable-next-line no-unused-vars
  corse_di_oggi_block = 'corse_di_oggi_block',
  // eslint-disable-next-line no-unused-vars
  corse_ultimi_risultati_block = 'corse_ultimi_risultati_block',
  prossime_corse_block = 'prossime_corse_block',
}
type ManagedComponentsType = keyof typeof enManagedComponents;
const managedComponentsOptions = Object.values(enManagedComponents);

type PossibleComponent = ManagedComponentsType;

type PossibleTemplate = 'templateIppica';

const IppicaComposer = <T,>({ pageId, cmsData }: { pageId: string; cmsData: DatoCmsVisualComposer[] }) => {
  const race = useTypedSelector(selectIppicaRaceDetail);

  const components = useMemo(() => {
    let bannerCounter = -1;
    return (cmsData ?? [])
      .filter((x) => managedComponentsOptions.includes(x._modelApiKey as enManagedComponents))
      .map((data, index) => {
        const title = (data.quickSlot ? data.quickSlot.title : data.title) ?? '';
        const subtitle = (data.quickSlot ? data.quickSlot.subtitle : '') ?? '';
        switch (data._modelApiKey as PossibleComponent) {
          case enManagedComponents.promo: {
            bannerCounter += 1;
            return (
              <BannerLandscapeWrapper
                key={`${data._modelApiKey}${index}`}
                pageId={pageId}
                showLoader={false}
                promoNumber={bannerCounter}
                removePaddingLeft
                removePaddingRight={true} // TODO CHECK FOR AVVENIMENTO IPPICA
              />
            );
          }
          case enManagedComponents.quick_slot: {
            return (
              data.quickSlot && <QuickSlot key={`${data._modelApiKey}${index}`} title={title} subtitle={subtitle} />
            );
          }
          case enManagedComponents.banner_on_page: {
            const bannerData = isTruthy(data?.banners?.length) ? convertInBannerType(data.banners![0]) : undefined;
            return (
              bannerData && (
                <BannerLandscape
                  key={`${data._modelApiKey}${index}`}
                  data={bannerData}
                  removePaddingLeft
                  removePaddingRight={true} // TODO CHECK FOR AVVENIMENTO IPPICA
                />
              )
            );
          }
          case enManagedComponents.corse_in_partenza_block: {
            return <IppicaInPartenza key={`${data._modelApiKey}${index}`} label={data.title} />;
          }
          case enManagedComponents.broadcast_block: {
            return <IppicaBroadcast key={`${data._modelApiKey}${index}`} />;
          }
          case enManagedComponents.corse_di_oggi_block: {
            return <IppicaWithTabContainer key={`${data._modelApiKey}${index}`} hasMarginBottom />;
          }
          case enManagedComponents.corse_news_block: {
            return <IppicaCarousel key={`${data._modelApiKey}${index}`} label={data.title} />;
          }
          case enManagedComponents.corse_ultimi_risultati_block: {
            return <IppicaBgContainer key={`${data._modelApiKey}${index}`} label={data.title} />;
          }
          case enManagedComponents.prossime_corse_block: {
            return race && <IppicaInPartenza key={`${data._modelApiKey}${index}`} label={data.title} />;
          }
          default: {
            return null; // <React.Fragment key={`fallback-${data._modelApiKey}`} />;
          }
        }
      })
      .filter((e) => !!e);
  }, [cmsData, pageId]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <React.Fragment>{components}</React.Fragment>;
};

export { IppicaComposer };
